<template>
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2 14">
		<path d="M-4e-8 7C-7e-8 7.55228.447715 8 1 8c.55228 0 1-.44772 1-1s-.44772-1-1-1C.447715 6-2e-8 6.44772-4e-8 7Z"/>
		<path d="M-4e-8 1C-7e-8 1.55228.447715 2 1 2c.55228 0 1-.44772 1-1C2 .447715 1.55228-2e-8 1-4e-8 .447715-7e-8-2e-8 .447715-4e-8 1Z"/>
		<path d="M-4e-8 13C-7e-8 13.5523.447715 14 1 14c.55228 0 1-.4477 1-1s-.44772-1-1-1C.447715 12-2e-8 12.4477-4e-8 13Z"/>
	</svg>
</template>
